import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { queryKeys } from "@/lib/queryClient";
import { resolveWorkspaceColor } from "@/lib/colors";
import type { Workspace } from "@/lib/types";

/**
 * For components that only know the workspace id (PostfachCard, SubmitPicker,
 * SubmitPage, etc). Reads the workspaces query cache, picks workspace.color
 * if set, else falls back to the deterministic hash. The query is shared
 * across the app — cached at 5min — so calling this hook from many cards
 * doesn't fan out into N fetches.
 */
export function useResolvedWorkspaceColor(workspaceId: string | null | undefined): string {
  const { data } = useQuery<Workspace[]>({
    queryKey: queryKeys.workspaces,
    queryFn: api.listWorkspaces,
    staleTime: 5 * 60_000,
  });
  if (!workspaceId) return resolveWorkspaceColor(null);
  const ws = (data ?? []).find((w) => w.id === workspaceId) ?? null;
  return resolveWorkspaceColor(ws, workspaceId);
}
